import { useEffect } from 'react';

interface KeyboardHandlers {
  onPlayPause?: () => void;
  onSeekBackward?: () => void;
  onSeekForward?: () => void;
  onFullscreen?: () => void;
  onMute?: () => void;
  onClose?: () => void;
}

export function useMasterClassKeyboard(handlers: KeyboardHandlers) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ignorar se estiver digitando em um input/textarea
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      switch (e.key) {
        case ' ':
          e.preventDefault();
          handlers.onPlayPause?.();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          handlers.onSeekBackward?.();
          break;
        case 'ArrowRight':
          e.preventDefault();
          handlers.onSeekForward?.();
          break;
        case 'f':
        case 'F':
          e.preventDefault();
          handlers.onFullscreen?.();
          break;
        case 'm':
        case 'M':
          e.preventDefault();
          handlers.onMute?.();
          break;
        case 'Escape':
          e.preventDefault();
          handlers.onClose?.();
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handlers]);
}
